const productData = [
  // 1
  {
    id: "blue-marine-gin",
    title: "BLUE MARINE GIN",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/blue-gin.png",
    relatedImages: [
      "/assets/images/products/blue-gin.png",
      "/assets/images/products/BLUE_MARINE_GIN/img_1.png",
      "/assets/images/products/BLUE_MARINE_GIN/img_2.png"
    ],
    types: [
      { title: "Available Sizes", desc: "90ml, 180ml, 375ml, 750ml, 1000ml" }
    ],
    details: {
      description: "Exquisite gin crafted from botanicals with premium quality.",
      highlights: [
        { label: "Origin", value: "India" },
        { label: "Sizes", value: "Multiple sizes" },
      ],
      packaging: "Glass bottles."
    }
  },

  // 2
  {
    id: "bishops-oak-whiskey",
    title: "BISHOPS OAK WHISKEY",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/WHISKEY.png",
    relatedImages: ["/assets/images/products/WHISKEY.png"],
    types: [
      { title: "Available Sizes", desc: "90ml, 180ml, 375ml, 750ml, 1000ml" }
    ],
    details: {
      description: "Premium Indian whiskey with rich aroma and smooth flavor.",
      highlights: [
        { label: "Origin", value: "India" },
        { label: "Sizes", value: "90ml to 1L" },
      ],
      packaging: "Glass bottles."
    }
  },

  //  3
  {
    id: "captain-kook-rhum",
    title: "CAPTAIN KOOK RHUM",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/rum.png",
    relatedImages: ["/assets/images/products/rum.png"],
    types: [
      { title: "Available Sizes", desc: "90ml, 180ml, 375ml, 750ml, 1000ml" }
    ],
    details: {
      description: "Smooth Indian rum for rich cocktails and neat enjoyment.",
      highlights: [
        { label: "Origin", value: "India" },
        { label: "Sizes", value: "Various" },
      ],
      packaging: "Glass bottles."
    }
  },

  // 4
  {
    id: "ria-lemon-gin",
    title: "RIA LEMON GIN",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/lemon-gin.png",
    relatedImages: ["/assets/images/products/lemon-gin.png"],
    types: [
      { title: "Available Sizes", desc: "90ml, 180ml, 375ml, 750ml, 1000ml" }
    ],
    details: {
      description: "Refreshing lemon-infused gin with vibrant citrus notes.",
      highlights: [
        { label: "Origin", value: "India" },
        { label: "Sizes", value: "Various" },
      ],
      packaging: "Glass bottles."
    }
  },

  // 5
  {
    id: "jamaican-express-whiskey",
    title: "JAMAICAN EXPRESS WHISKEY",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/EXPRESS_WHISKEY.png",
    relatedImages: ["/assets/images/products/EXPRESS_WHISKEY.png"],
    types: [
      { title: "Available Sizes", desc: "90ml, 180ml, 375ml, 750ml, 1000ml" }
    ],
    details: {
      description: "Bold Indian whiskey inspired by Jamaican distilling style.",
      highlights: [
        { label: "Origin", value: "India" },
        { label: "Sizes", value: "Multiple sizes" },
      ],
      packaging: "Glass bottles."
    }
  },

  // 6
  {
    id: "royal-blue-whiskey",
    title: "ROYAL BLUE WHISKEY",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/BLUE_WHISKEY.png",
    relatedImages: ["/assets/images/products/BLUE_WHISKEY.png"],
    types: [
      { title: "Available Sizes", desc: "90ml, 180ml, 375ml, 750ml, 1000ml" }
    ],
    details: {
      description: "Signature Indian whiskey with refined taste and finish.",
      highlights: [
        { label: "Origin", value: "India" },
        { label: "Sizes", value: "Various" },
      ],
      packaging: "Glass bottles."
    }
  },

  // 7
  {
    id: "santa-isabel-beer",
    title: "Santa Isabel Big Bertha Beer",
    subTitle: "Origin: Spain",
    cardImage: "/assets/images/products/Bertha_Beer.png",
    relatedImages: ["/assets/images/products/Bertha_Beer.png",
      "/assets/images/products/Beer/beer1.png"
    ],
    details: {
      description: "12% Alcohol Vol. 50cl cans. 20ft = 1573 cases, 40ft = 1863 cases.",
      highlights: [
        { label: "Alcohol", value: "12%" },
        { label: "Can Size", value: "50cl" },
        { label: "Origin", value: "Spain" },
      ],
      packaging: "24 cans per case."
    }
  },



  // 8
  {
    id: "hardware",
    title: "Hardware",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/hardware.png",
    relatedImages: [
      "/assets/images/products/hardware.png",
    ],
    types: [
      {
        title: "Available Sizes",
        desc: "90ml, 180ml, 375ml, 750ml, 1000ml"
      }
    ],
    details: {
      description:
        "A diverse selection of high-quality hardware components sourced from India. Designed for durability, precision, and reliable performance across construction and industrial applications.",
      highlights: [
        { label: "Origin", value: "India" },
        { label: "Sizes", value: "90ml, 180ml, 375ml, 750ml, 1000ml" },
        { label: "Material", value: "Stainless Steel / Iron / Alloy" },
        { label: "Usage", value: "Construction, Industrial, Home Repair" }
      ],
      packaging: "Standard export packaging, moisture-resistant corrugated boxes or crates."
    }
  },

  //9
  {
    id: "motorcyclespareparts",
    title: " Motorcycle Spare Parts",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/Motorcycle_Spare_Parts/img1.png",
    relatedImages: [
      "/assets/images/products/Motorcycle_Spare_Parts/img1.png",
    ],
    types: [
      {
        title: "Available Sizes",
        desc: "90ml, 180ml, 375ml, 750ml, 1000ml"
      }
    ],
    details: {
      description:
        "A comprehensive range of high-performance motorcycle spare parts made in India. Engineered for reliability, durability, and compatibility with a wide variety of motorcycle brands, ensuring optimal performance and safety on the road.",
      highlights: [
        { label: "Origin", value: "India" },
        { label: "Sizes", value: "90ml, 180ml, 375ml, 750ml, 1000ml" },
        { label: "Material", value: "Stainless Steel / Iron / Alloy" },
        { label: "Usage", value: "Motorcycle Maintenance, Repair, and Customization" }
      ],
      packaging: "Sturdy export-grade packaging using moisture-resistant corrugated boxes, reinforced crates, and bubble wrap to ensure safe transportation and protection of all motorcycle parts during transit."
    },
    relatedImages: ["/assets/images/products/Motorcycle_Spare_Parts/img1.png",
      "/assets/images/products/Motorcycle_Spare_Parts/img2.png",
      "/assets/images/products/Motorcycle_Spare_Parts/img3.png",
      "/assets/images/products/Motorcycle_Spare_Parts/img4.png"
    ],
  },


  // 10
  {
    id: "rice",
    title: "IR64 White & Parboiled Rice",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/Parboiled_Rice.png",
    relatedImages: ["/assets/images/products/Parboiled_Rice.png",
      "/assets/images/products/White_Parboiled_Rice/img_1.png",
      "/assets/images/products/White_Parboiled_Rice/img_2.png",
      "/assets/images/products/White_Parboiled_Rice/img_3.png",
      "/assets/images/products/White_Parboiled_Rice/img_4.png",
      "/assets/images/products/White_Parboiled_Rice/img_5.png"
    ],
    details: {
      description: "IR64 Long Grain 5% Broken (White & Parboiled).",
      highlights: [
        { label: "Variety", value: "IR64 Long Grain" },
        { label: "Broken %", value: "5%" },
        { label: "Types", value: "White / Parboiled" },
        { label: "Origin", value: "India" },
      ],
      packaging: "Yellow / Blue PP bags."
    }
  },

  // 11
  {
    id: "flour",
    title: "Flour",
    subTitle: "Origin: Turkey",
    cardImage: "/assets/images/products/Flour.png",
    relatedImages: ["/assets/images/products/Flour.png",
      "/assets/images/products/Flour/floul1.png"
    ],
    details: {
      description: "Fortified multi-purpose wheat flour for maandazi, chapati, cookies, etc.",
      highlights: [
        { label: "Usage", value: "Baking and general use" },
        { label: "Weight", value: "25kg" },
        { label: "Origin", value: "Turkey" },
      ],
      packaging: "25kg PP bag."
    }
  },

  // 12
  {
    id: "sugar",
    title: "Sugar",
    subTitle: "Origin: India/Brazil",
    cardImage: "/assets/images/products/Sugar.png",
    relatedImages: ["/assets/images/products/Sugar.png"],
    details: {
      description: "Raw-Brown Sugar packed in 50kg PP/HDPE bags.",
      highlights: [
        { label: "Type", value: "Raw-Brown" },
        { label: "Bag Size", value: "50kg" },
        { label: "Origin", value: "India / Brazil" },
      ],
      packaging: "PP Blue/White or HDPE Bags."
    }
  },

  // 13
  {
    id: "carbon-zinc-battery",
    title: "Carbon Zinc Battery",
    subTitle: "Origin: China",
    cardImage: "/assets/images/products/Zinc_Battery.png",
    relatedImages: ["/assets/images/products/Zinc_Battery.png"],
    details: {
      description: "Available in R20S, R14S, R6S, R03, D Size, C Size, AA Size, AAA Size.",
      highlights: [
        { label: "Type", value: "Carbon Zinc" },
        { label: "Sizes", value: "R20S, R14S, R6S, R03, D, C, AA, AAA" },
        { label: "Origin", value: "China" },
      ],
      packaging: "Standard battery packaging for bulk and retail."
    }
  },

  // 14
  {
    id: "palm-oil",
    title: "Palm Oil",
    subTitle: "Origin: Indonesia",
    cardImage: "/assets/images/products/Palm_Oil.png",
    relatedImages: ["/assets/images/products/Oil/oil1.png",
      "/assets/images/products/Palm_Oil.png"
    ],
    details: {
      description: "Palm Oil CP6/IV60, CP8/IV57, CP10/IV56",
      highlights: [
        { label: "Grades", value: "CP6, CP8, CP10" },
        { label: "Packaging", value: "20L Jerry Can" },
        { label: "Origin", value: "Indonesia" },
      ],
      packaging: "20L Jerry Can"
    }
  },

  // 15
  {
    id: "exercise-books",
    title: "Exercise Books",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/Exercise_Book.png",
    relatedImages: ["/assets/images/products/Exercise_Book.png",
      "/assets/images/products/Book/book_1.png"
    ],
    details: {
      description: "220 mm × 170 mm, 36, 48, 96, 200 sheets, Square Line.",
      highlights: [
        { label: "Size", value: "220 mm × 170 mm" },
        { label: "Sheets", value: "36, 48, 96, 200" },
        { label: "Line Type", value: "Square Line" },
        { label: "Origin", value: "India" },
      ],
      packaging: "Shrink-wrapped bundles or cartons."
    }
  },

  // 16
  {
    id: "ethyl-alcohol",
    title: "Ethyl Alcohol 96% V/V",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/Ethyl_Alcohol.png",
    relatedImages: ["/assets/images/products/Ethyl_Alcohol.png"],
    details: {
      description: "Undenatured Ethyl Alcohol. HS Code: 22071090.",
      highlights: [
        { label: "Alcohol Content", value: "96% V/V" },
        { label: "HS Code", value: "22071090" },
        { label: "Origin", value: "India" },
      ],
      packaging: "Secure chemical-grade export packaging."
    }
  },




  // 17
  {
    id: "garbage-bags",
    title: "Plastic Bags",
    subTitle: "Origin: China",
    cardImage: "/assets/images/products/Garbage_Bags.png",
    relatedImages: ["/assets/images/products/Garbage_Bags.png",
      "/assets/images/products/Bags/bag1.png",
      "/assets/images/products/Bags/bag2.png",

    ],
    details: {
      description: <> Plastic Bags  HDPE / LDPE / Biodegradable / Recycled
      </>,
      highlights: [
        { label: "Material", value: "HDPE / LDPE / Biodegradable / Recycled" },
        { label: "HS Code", value: "39232100" },
        { label: "Origin", value: "China" },
      ],
      packaging: "Custom sizes & patterns."
    }
  },


  // 18
  {
    id: "china_plastic",
    title: "Liner Bags",
    subTitle: "Origin: India",
    cardImage: "/assets/images/products/China_plastic/bag3.png",
    relatedImages: ["/assets/images/products/China_plastic/bag3.png",
      "/assets/images/products/China_plastic/bag4.png",
      "/assets/images/products/China_plastic/bag5.png"

    ],
    details: {
      description: <> LINER BAGS  30" x 48"  (57 Microns) - 100gms
      </>,
      highlights: [
        { label: "Material", value: "HDPE / LDPE / Biodegradable / Recycled" },
        { label: "HS Code", value: "39232100" },
        { label: "Origin", value: " China" },
      ],
      packaging: "Custom sizes & patterns."
    }
  },

];

export default productData;
